/* eslint-disable */

export enum ConservatoryStepValid {
	Unknown = 0,
	Valid = 1,
	Invalid = 2,
	
}
